import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';

export interface SpinnerState {
	visible: boolean;
	message: string;
}

@Injectable({ providedIn: 'root' })
export class SpinnerService {
	private visibleSubject = new BehaviorSubject<boolean>(false);
	private messageSubject = new BehaviorSubject<string>('Please wait...');
	private defaultMessage = 'Please wait...';

	spinnerState$ = combineLatest([
		this.visibleSubject,
		this.messageSubject,
	]).pipe(
		map(([visible, message]) => ({ visible, message }))
	);

	show(message?: string) {
		if (message) {
			this.messageSubject.next(message);
		} else {
			this.messageSubject.next(this.defaultMessage);
		}
		this.visibleSubject.next(true);
	}

	hide() {
		this.visibleSubject.next(false);
	}
}